
		<info-modal [title]="title" (onOk)="ok()">
			<filterForm [isAccessorFilters]="true" [addFilterParams]="{}"></filterForm>
		</info-modal>
	